import React, { useState, useEffect } from 'react';
import axios from 'axios';

//const API = process.env.REACT_APP_API_URL || 'https://sohaibenterprises.cloud/api';
const API = 'http://localhost:5000/api';
const SalesTab = () => {
  const [sales, setSales]         = useState([]);
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [showForm, setShowForm]   = useState(false);
  const [formData, setFormData]   = useState({
    product_id: '', customer_name: '', customer_phone: '',
    quantity_sold: '', price_per_roll: '', sale_date: '', notes: ''
  });
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const fetchAll = async () => {
    try {
      const [salesRes, invRes] = await Promise.all([
        axios.get(`${API}/tape/sales`, { headers }),
        axios.get(`${API}/tape/inventory`, { headers }),
      ]);
      setSales(salesRes.data.data || []);
      setInventory(invRes.data.data || []);
    } catch {
      setError('Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchAll(); }, []);

  // Auto calculate total when quantity or price changes
  const totalAmount = (formData.quantity_sold && formData.price_per_roll)
    ? (formData.quantity_sold * formData.price_per_roll).toLocaleString()
    : '0';

  const handleSave = async () => {
    if (!formData.product_id || !formData.quantity_sold || !formData.price_per_roll || !formData.sale_date) {
      setError('Product, quantity, price and date are required');
      return;
    }
    setSaving(true);
    try {
      await axios.post(`${API}/tape/sales`, formData, { headers });
      setShowForm(false);
      setFormData({ product_id: '', customer_name: '', customer_phone: '', quantity_sold: '', price_per_roll: '', sale_date: '', notes: '' });
      fetchAll();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to save sale');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this sale record?')) return;
    try {
      await axios.delete(`${API}/tape/sales/${id}`, { headers });
      fetchAll();
    } catch {
      setError('Failed to delete');
    }
  };

  const fmt = (n) => `Rs ${Number(n || 0).toLocaleString()}`;

  if (loading) return <div style={{ textAlign: 'center', padding: '60px', color: '#7f8c8d' }}>Loading...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#2c3e50', margin: 0 }}>💰 Sales</h2>
        <button
          onClick={() => { setShowForm(true); setError(''); }}
          style={{ padding: '12px 24px', background: '#f39c12', border: 'none', borderRadius: '10px', color: 'white', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}
        >
          + Record Sale
        </button>
      </div>

      {error && (
        <div style={{ background: '#fdecea', border: '1px solid #e74c3c', borderRadius: '10px', padding: '12px 16px', marginBottom: '20px', color: '#e74c3c' }}>
          {error}
        </div>
      )}

      {showForm && (
        <div style={{ background: 'white', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 15px rgba(0,0,0,0.08)', marginBottom: '24px', border: '2px solid #f39c12' }}>
          <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#2c3e50', marginBottom: '20px' }}>Record New Sale</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Product *</label>
              <select
                value={formData.product_id}
                onChange={e => setFormData({ ...formData, product_id: e.target.value })}
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              >
                <option value="">Select Product</option>
                {inventory.map(p => (
                  <option key={p.product_id} value={p.product_id}>
                    {p.product_name} (Stock: {p.current_stock})
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Customer Name</label>
              <input
                type="text"
                value={formData.customer_name}
                onChange={e => setFormData({ ...formData, customer_name: e.target.value })}
                placeholder="e.g. Ahmed Store"
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Customer Phone</label>
              <input
                type="text"
                value={formData.customer_phone}
                onChange={e => setFormData({ ...formData, customer_phone: e.target.value })}
                placeholder="e.g. 0300-1234567"
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Quantity (Rolls) *</label>
              <input
                type="number"
                value={formData.quantity_sold}
                onChange={e => setFormData({ ...formData, quantity_sold: e.target.value })}
                placeholder="e.g. 10"
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Price Per Roll (Rs) *</label>
              <input
                type="number"
                value={formData.price_per_roll}
                onChange={e => setFormData({ ...formData, price_per_roll: e.target.value })}
                placeholder="e.g. 50"
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Sale Date *</label>
              <input
                type="date"
                value={formData.sale_date}
                onChange={e => setFormData({ ...formData, sale_date: e.target.value })}
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>Notes</label>
              <input
                type="text"
                value={formData.notes}
                onChange={e => setFormData({ ...formData, notes: e.target.value })}
                placeholder="Optional"
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
          </div>

          {/* ── Auto calculated total ── */}
          <div style={{ marginTop: '16px', padding: '16px', background: '#f8f9fa', borderRadius: '10px' }}>
            <span style={{ fontSize: '16px', fontWeight: '600', color: '#2c3e50' }}>
              Total Amount: <span style={{ color: '#27ae60', fontSize: '20px' }}>Rs {totalAmount}</span>
            </span>
          </div>

          <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
            <button onClick={handleSave} disabled={saving} style={{ padding: '10px 24px', background: '#f39c12', border: 'none', borderRadius: '8px', color: 'white', cursor: 'pointer', fontWeight: '600' }}>
              {saving ? 'Saving...' : 'Save Sale'}
            </button>
            <button onClick={() => setShowForm(false)} style={{ padding: '10px 24px', background: '#f0f0f0', border: 'none', borderRadius: '8px', color: '#555', cursor: 'pointer', fontWeight: '600' }}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* ── SALES TABLE ── */}
      <div style={{ background: 'white', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 15px rgba(0,0,0,0.08)' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f9fa' }}>
                {['#', 'Customer', 'Product', 'Qty', 'Price/Roll', 'Total', 'Date', 'Actions'].map(h => (
                  <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: '13px', color: '#7f8c8d', fontWeight: '600' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sales.map((sale, index) => (
                <tr key={sale.id} style={{ borderBottom: '1px solid #f0f0f0', background: index % 2 === 0 ? 'white' : '#fafafa' }}>
                  <td style={{ padding: '12px 16px', color: '#7f8c8d' }}>{index + 1}</td>
                  <td style={{ padding: '12px 16px', fontWeight: '600', color: '#2c3e50' }}>{sale.customer_name || 'Walk-in'}</td>
                  <td style={{ padding: '12px 16px', color: '#555' }}>{sale.product_name}</td>
                  <td style={{ padding: '12px 16px', color: '#555' }}>{sale.quantity_sold} rolls</td>
                  <td style={{ padding: '12px 16px', color: '#555' }}>{fmt(sale.price_per_roll)}</td>
                  <td style={{ padding: '12px 16px', fontWeight: '700', color: '#27ae60' }}>{fmt(sale.total_amount)}</td>
                  <td style={{ padding: '12px 16px', color: '#7f8c8d' }}>{new Date(sale.sale_date).toLocaleDateString()}</td>
                  <td style={{ padding: '12px 16px' }}>
                    <button
                      onClick={() => handleDelete(sale.id)}
                      style={{ padding: '6px 14px', background: '#e74c3c', border: 'none', borderRadius: '6px', color: 'white', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
              {sales.length === 0 && (
                <tr>
                  <td colSpan="8" style={{ padding: '40px', textAlign: 'center', color: '#7f8c8d' }}>No sales recorded yet.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SalesTab;